import { Head } from "@inertiajs/react";
import { t } from "@travily/i18n";
import { foundingMemberCreatorPath, foundingMemberCreatorStagePath } from "@travily/routes";
import type FoundingMemberCreatorIndividualSubscribe from "@travily/types/pages/FoundingMemberCreatorIndividualSubscribe";
import { useCreatorTopBarActions } from "@/lib/wizard/use-creator-top-bar-actions";
import { useWizardForm } from "@/lib/wizard/use-wizard-form";
import { FoundingMemberSubscribeStepView } from "./show.view";

type FormData = {
  individual_profile: {
    newsletter_consent: "yes" | "no" | null;
  };
};

const FIELD = "individual_profile.newsletter_consent";

const SubscribeStep = ({ stage_index, stage_order, individual_profile }: FoundingMemberCreatorIndividualSubscribe) => {
  const { form, validate, fieldError, currentStage, totalStages, onBack, onPrimary, primaryPending } =
    useWizardForm<FormData>({
      routes: {
        stageUrl: (stage) => foundingMemberCreatorStagePath("individual", stage),
        entryUrl: foundingMemberCreatorPath(),
      },
      stageName: "subscribe",
      stageIndex: stage_index,
      stageOrder: stage_order,
      initialData: { individual_profile: { newsletter_consent: individual_profile.newsletter_consent ?? null } },
    });

  const error = fieldError(FIELD);

  const topBarActions = useCreatorTopBarActions();

  return (
    <>
      <Head title={t("web.founding_members.creator.steps.individual.subscribe.show.meta_title")}>
        <meta
          name="description"
          content={t("web.founding_members.creator.steps.individual.subscribe.show.meta_description")}
        />
      </Head>
      <FoundingMemberSubscribeStepView
        currentStage={currentStage}
        totalStages={totalStages}
        value={form.data.individual_profile.newsletter_consent}
        error={error}
        primaryPending={primaryPending}
        topBarActions={topBarActions}
        onBack={onBack}
        onPrimary={onPrimary}
        onSelectConsent={(value) => {
          form.setData(FIELD, value);
          validate(FIELD);
        }}
      />
    </>
  );
};

export default SubscribeStep;
